export const LOADING_EMPLOYEE_TRAINING = "LOADING_EMPLOYEE_TRAINING";
export const GET_EMPLOYEE_TRAINING_LIST = "GET_EMPLOYEE_TRAINING_LIST";
export const GET_EMPLOYEE_TRAINING_BY_ID = "GET_EMPLOYEE_TRAINING_BY_ID";
export const REMOVE_EMPLOYEE_TRAINING = "REMOVE_EMPLOYEE_TRAINING";
export const ADD_EMPLOYEE_TRAINING = "ADD_EMPLOYEE_TRAINING";
export const UPDATE_EMPLOYEE_TRAINING = "UPDATE_EMPLOYEE_TRAINING";